export const promotionCategoryCode = "11417";
export const discontinuedCategoryCode = "11829";
